import React from "react";
import DashboardLayout from "../../layouts/Dashboard";
import EHealthProtocolCRUDTable from "../../components/CRUD/Tables/EHealthProtocolCRUDTable";

const EHealthList = () => {
    return (
        <DashboardLayout>
            <EHealthProtocolCRUDTable />
        </DashboardLayout>
    );
};

export default EHealthList;
